module.exports = __webpack_public_path__ + "img/pointBg.b853249e.png";